import React from "react";
import { Link } from "react-router-dom";
import { RiEmotionSadLine } from 'react-icons/ri';

function NotFound() {
  return (
    <>
      <section>
        <div className="container">
          <div className="page-notFound">
            <h2>404</h2>
            <p>Page Not Found</p>
            <Link to="/">GO back to home page</Link>
           <div>
           <RiEmotionSadLine className="icon"/>
           </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NotFound;
